import Cookies from 'js-cookie';
import { parseDateToString } from '@utils/helpers';

const PREFIX = '[YOUR JOURNEY]';

const cookieOptions = { secure: process.env.NODE_ENV === 'production', sameSite: 'lax' };

export const DATE_PARAMS = ['fromDate', 'toDate', 'spaDate'];
export const JSON_PARAMS = ['childAges', 'rooms'];

export const CHANGE_JOURNEY_PARAM_REQUEST = `${PREFIX} CHANGE_JOURNEY_PARAM_REQUEST`;
export const CHANGE_JOURNEY_PARAM_SUCCESS = `${PREFIX} CHANGE_JOURNEY_PARAM_SUCCESS`;

export const changeJourneyParamRequest = {
  type: CHANGE_JOURNEY_PARAM_REQUEST,
};

export const changeJourneyParamSuccess = (paramName, value) => ({
  type: CHANGE_JOURNEY_PARAM_SUCCESS,
  paramName,
  value,
});

export const changeJourneyParam = (paramName, value) => (dispatch) => {
  dispatch(changeJourneyParamRequest);
  const parsedValue = DATE_PARAMS.includes(paramName)
    ? parseDateToString(value)
    : JSON_PARAMS.includes(paramName)
    ? JSON.stringify(value)
    : value;

  if (typeof window !== 'undefined') {
    Cookies.remove(paramName);
    if (parsedValue) {
      Cookies.set(paramName, parsedValue, cookieOptions);
    }
  }
  dispatch(changeJourneyParamSuccess(paramName, parsedValue));
};

export const SET_JOURNEY_PARAMS = `${PREFIX} SET_JOURNEY_PARAMS`;

export const setJourneyParams = (params) => {
  const sanitizedParams = {
    ...params,
  };

  for (const param of JSON_PARAMS) {
    if (typeof params[param] !== 'string') {
      sanitizedParams[param] = JSON.stringify(params[param]);
    }
  }

  return {
    type: SET_JOURNEY_PARAMS,
    params: sanitizedParams,
  };
};
